// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React, { useCallback, useRef } from "react";
import * as R from "ramda";

import { CriteriaSelect as StyledSegmentValue } from "../CriteriaSelect/styles";
import Dropdown from "./AgeDropdown";
import { Value } from "./styles";
import useBoolean from "src/hooks/useBoolean";
import { RelativeBox } from "src/styles/box";
import PlatformUsageName from "./PlatformUsageName";
import { SpacedFlex } from "src/styles/box";
import Icons from "src/icons";

type Props = {
  value: Array<number>,
  handleChange: Function
};

const SelectAge = ({ value, handleChange }: Props) => {
  const { value: dropdown, toggleBoolean } = useBoolean();
  const outerRef = useRef();

  const handleSelect = useCallback(
    (id: number) => {
      if (R.includes(id, value)) {
        const newValue = R.reject(val => val === id, value);
        handleChange(newValue);
      } else {
        handleChange([...value, id]);
      }
    },
    [value, handleChange]
  );

  return (
    <RelativeBox ref={outerRef}>
      <StyledSegmentValue onClick={toggleBoolean}>
        {value.length === 0 && (
          <SpacedFlex>
            <Value>{i18n.t(k.SELECT_TIMEPERIOD)}</Value>
            <Icons type="caretDown" />
          </SpacedFlex>
        )}

        {value.length !== 0 && (
          <SpacedFlex>
            {value.length === 1 ? (
              <Value>
                <PlatformUsageName id={value[0]} />
              </Value>
            ) : (
              <Value>
                {value.length} {i18n.t(k.SELECTED)}
              </Value>
            )}
            <Icons type="caretDown" />
          </SpacedFlex>
        )}
      </StyledSegmentValue>
      {dropdown && (
        <Dropdown
          value={value}
          outerRef={outerRef}
          handleClose={toggleBoolean}
          handleSelect={handleSelect}
        />
      )}
    </RelativeBox>
  );
};
export default SelectAge;
